import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { Heat } from "../models/Heat";
import { MILL_1 } from "@/setup/mill-config/mill-config";

export const getHeats = async (
	params: {
		includeInactive?: boolean;
		includeLastYear?: boolean;
		sectionId?: number;
		defaultAreaId?: number;
	} = {},
	signal?: AbortSignal,
): Promise<Heat[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "IncludeInactive", value: params.includeInactive || false },
		{ name: "SectionId", value: params.sectionId ?? null },
		{ name: "IncludeLastYear", value: params.includeLastYear ?? false },
	];

	const resp = await apiService.callV2(
		params.defaultAreaId == MILL_1.id ? "[M1].[GetHeats]" : "[M2].[GetHeats]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Heat[];
	} else {
		throw new Error(resp.message || "Error fetching heats");
	}
};
